module.exports = "pegasus/assets/blocks/column-lp1-basic.png";